import { render, staticRenderFns } from "./DoseTakenDialog.vue?vue&type=template&id=dd86db6a&"
import script from "./DoseTakenDialog.vue?vue&type=script&lang=js&"
export * from "./DoseTakenDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports